module.exports = __webpack_public_path__ + "pcsg/img/may1.38169a67.png";